const APPLIANCE_TYPE_OPTIONS = [
  "Lave-Linge",
  "Refrigerateur",
  "Aspirateur",
  "Lave-Vaiselle",
  "Blender",
  "Machine a cafe",
  "Machine à laver",
  "Cave a vin",
  "Grille-pain",
  "Hotte",
  "Chauffe-eau",
  "Seche-Linge",
  "Congelateur",
  "Barbecue",
  "Friteuse",
  "Radiateur",
  "Climatiseur",
  "Four",
  "Plaque de cuisson",
  "Autres",
];

export { APPLIANCE_TYPE_OPTIONS };
